import { render, staticRenderFns } from "./EventCreateSubmit.vue?vue&type=template&id=9f9dc60a&"
import script from "./EventCreateSubmit.vue?vue&type=script&lang=js&"
export * from "./EventCreateSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f9dc60a')) {
      api.createRecord('9f9dc60a', component.options)
    } else {
      api.reload('9f9dc60a', component.options)
    }
    module.hot.accept("./EventCreateSubmit.vue?vue&type=template&id=9f9dc60a&", function () {
      api.rerender('9f9dc60a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/events/steps/EventCreateSubmit.vue"
export default component.exports